<template>
  <div>
    <el-dialog
      :visible="visible"
      @close="cancel(false)"
    >
      <el-form ref="form">
        <el-form-item label="端口可用范围：">{{portInvalid}}</el-form-item>
        <el-form-item label="您可以指定端口智能分配的开始位置：">
          <el-input v-model="startPosi" style="width:100px;"></el-input>
        </el-form-item>
        <el-row style="text-align:center;">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="cancel(false)">不指定</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: {
      sourceVals: {
        type: Array,
        required: true
      },
      visible: {
        type: Boolean
      }
    },
    data: vm => ({
      portInvalid: '',
      startPosi: '',
    }),
    created() {
      //let inner = this.sourceVals.ip[0]
      if (this.sourceVals && this.sourceVals.length > 0) {
        let inner = this.sourceVals[0]
        let arr = []
        if (inner.ports && inner.ports.length > 0) {
          arr = [...inner.ports]
        }
        if (inner.portRange && inner.portRange.length > 0) {
          inner.portRange.forEach(pr => {
            arr.push(pr.start + '~' + pr.end)
          })
        }
        this.portInvalid = arr.join(',')
      }
    },
    methods: {
      save() {
        this.cancel(this.startPosi)
      },
      cancel(val) {
        this.$emit('closeIntelligent', val ? val : false)
      }
    }
  }
</script>
